// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"da57722e","239":"1375c13d","453":"46aaf347","455":"1ffd537d"}[chunkId] + ".chunk.js";
};